import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";
import { qk } from "@/lib/query-keys";
import { toSearchParams, type TimeRange } from "@/lib/time-range";
import { TrafficSchema, type Traffic } from "@/lib/validation";

export interface UseMetricOptions {
  enabled?: boolean;
}

export function useTraffic(range: TimeRange, options: UseMetricOptions = {}) {
  return useQuery<Traffic>({
    queryKey: qk.metrics.traffic(range),
    queryFn: async ({ signal }) => {
      const raw = await api.get<unknown>(
        `/api/v1/metrics/traffic?${toSearchParams(range).toString()}`,
        { signal },
      );
      return TrafficSchema.parse(raw);
    },
    enabled: options.enabled !== false,
    staleTime: 60_000,
  });
}
